import { JsonSerializable } from '../shared/jsonSerializable';
import { Package } from '../entity/package';
import { Product } from '../entity/product';
import { Job } from '../entity/job';

export class ProductPackage extends JsonSerializable {

  code: string;
  label: string;
  product: Product;
  package: Package;
  job: Job;

  constructor() {
    super();
    this.code = null;
    this.label = null;
    this.product = null;
    this.package = null;
    this.job = null;
  }

  fromJSON(jsonObj: Object) {
    for (const propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {
        if (jsonObj[propName] instanceof Object) {
          if (propName === 'product') {
            this[propName] = new Product();
          } else if (propName === 'package') {
            this[propName] = new Package();
          } else if (propName === 'job') {
            this[propName] = new Job();
          }
          this[propName].fromJSON(jsonObj[propName]);
        } else {
          this[propName] = jsonObj[propName];
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entity/product-package.ts